/*
 * @Author: your name
 * @Date: 2021-07-16 13:29:59
 * @LastEditTime: 2021-07-19 14:39:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /information-vue/code/src/plugins/http.js
 */
"use strict";
import { Message, Loading } from "element-ui";
import {getToken, removeToken, removetUserInfo, removeUserInfo} from "@/utils/auth.js";
import store from '@/store'
import axios from "axios";
import errorCode from '@/utils/errorCode.js'
import qs from "qs";
import {tansParams} from "@/utils/ruoyi";
// 上传请求地址
const imgURL = "";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const service = axios.create({
  baseURL: process.env.baseURL || "",
  timeout: 5 * 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
});

// 封装get请求
const get = (url, params = {}) => {
  return service({
    url: url,
    method: "get",
    params: { ...params, ts: new Date().getTime() },
  });
};
// 封装post请求
const post = (url, data = {}, headers = { "Content-type": "application/json" }) => {
  return service({
    url: url,
    method: "post",
    headers: headers,
    data: JSON.stringify(data),
  });
};
//删除请求
const del = (url, data = {}) => {
  return service({
    url: url,
    method: "delete",
    data: JSON.stringify(data),
  });
};
// 封装post下载请求
const DownloadDb = (url, data = {}) => {
  return service({
    url: url,
    method: "post",
    headers: { "Content-type": "application/json" },
    data: JSON.stringify(data),
    responseType: 'blob'
  });
};
const Downloadget = (url, params = {}) => {
  return service({
    url: url,
    method: "get",
    headers: { "Content-type": "application/octet-stream" },
    params: params,
    responseType: 'blob'
  });
};
// 封装de请求
const login = (url, data = {}) => {
  return service({
    url: url,
    method: "post",
    headers: { "Content-type": "application/x-www-form-urlencoded" },
    data: qs.stringify(data),
  });
};

// 上传请求
const upload = (url, data = {}) => {
  service({
    method: "post",
    url: url,
    headers: {
      "Content-type": "multipart/form-data",
    },
    data: data,
  });
};

let loadCounter = {
  count: 0,
  show: () => {
    loadCounter.count++;
    if (loadCounter.count > 0) {
      store.dispatch('loading/loading', true)
    }
  },
  hide: () => {
    loadCounter.count--;
    if (loadCounter.count <= 0) {
      store.dispatch('loading/loading', false)
    }
  }
}

let messageIndex = 0
let isRelogin = { show: false }
const blobToJson=(blob)=> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(reader.result);
        resolve(json);
      } catch (error) {
        reject(new Error('无法解析Blob为JSON: ' + error.message));
      }
    };
    reader.onerror = () => {
      reject(new Error('读取Blob失败'));
    };
    reader.readAsText(blob);
  });
}
service.interceptors.request.use(
  function (config) {
    messageIndex = 0;

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getToken() && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config;
  },
  function (error) {
    // loadCounter.hide();
    // Do something with request error
    return Promise.reject(error);
  }
);


// Add a response interceptor
service.interceptors.response.use(
  function (res) {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // // 二进制数据则直接返回
    // if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
    //   return res.data
    // }
    // 如果是二进制流
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      // 如果是错误响应（状态码非200），尝试从Blob中读取错误信息
      if (res.request.status == 200) {
        try {
          const errorJson = blobToJson(res.data);
          if (errorJson && errorJson.code) {
            // 这里处理错误码
            if (errorJson.code === 401) {
              if (!isRelogin.show) {
                isRelogin.show = true
                Message({
                  showClose: true,
                  message: '登录状态已过期，请重新登陆！',
                  type: 'warning',
                })
                removeUserInfo();
                removeToken()
                window.location = "/login"
              }
              return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
            } else if (code === 500) {
              Message({ message: msg, type: 'error' })
              return Promise.reject(new Error(msg))
            } else if (code === 601) {
              Message({ message: msg, type: 'warning' })
              return Promise.reject('error')
            } else if (code !== 200) {
              Notification.error({ title: msg })
              return Promise.reject('error')
            } else {
              return res.data
            }
            Message.error(errorJson.msg || '请求失败');
            return Promise.reject(new Error(errorJson.msg));
          }
        } catch (e) {
          // 如果不是JSON，就是正常的二进制文件
          console.log('Blob不是JSON格式，返回原始数据');
        }
      }

      // 正常返回二进制数据
      return res.data;
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        Message({
          showClose: true,
          message: '登录状态已过期，请重新登陆！',
          type: 'warning',
        })
        removeUserInfo();
        removeToken()
        window.location = "/login"

      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
    error => {
      console.log('err' + error)
      let { message } = error
      if (message == "Network Error") {
        message = "后端接口连接异常"
      } else if (message.includes("timeout")) {
        message = "系统接口请求超时"
      } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常"
      }
      Message({ message: message, type: 'error', duration: 5 * 1000 })
      return Promise.reject(error)
    }
);

//eslint-disable-next-line
export default {
  DownloadDb,
  Downloadget,
  get,
  post,
  del,
  login,
  upload,
  imgURL,
  axios,
};
